import styled, { css } from 'styled-components/macro'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
  `}
  font-weight: normal;
  font-size: 24px;
  padding-left: 8px;
`
